var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberShine7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#number-shine-7_svg__filter0_d_13479_88665)",
    clipRule: "evenodd",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.863 7.04h16.424v4.386L13.911 29H6.117l6.864-15.49H4.863V7.04zm2 2v2.47h9.191L9.191 27h3.39l6.706-15.977V9.04H6.863z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.863 7.04h16.424v4.386L13.911 29H6.117l6.864-15.49H4.863V7.04zm2 2v2.47h9.191L9.191 27h3.39l6.706-15.977V9.04H6.863z",
    stroke: "#02A7DB",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "number-shine-7_svg__filter0_d_13479_88665",
    x: 0.363,
    y: 2.539,
    width: 25.424,
    height: 30.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.654902 0 0 0 0 0.858824 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13479_88665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13479_88665",
    result: "shape"
  })))));
}

export default SvgNumberShine7;